/* eslint-disable @typescript-eslint/naming-convention */
import { createTheme } from '@mui/material/styles';

import { Theme } from '@mui/material/styles';

export interface ThemeInterface {
  theme: Theme;
}

declare module '@mui/material/styles' {
  interface Palette {
    lightgrey: Palette['primary'];
    darkgrey: Palette['primary'];
    basicblack: Palette['primary'];
    mediumgrey: Palette['primary'];
    danger: Palette['primary'];
    lightgreen: Palette['primary'];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    lightgrey?: PaletteOptions['primary'];
    darkgrey?: PaletteOptions['primary'];
    basicblack?: PaletteOptions['primary'];
    mediumgrey?: PaletteOptions['primary'];
    danger?: PaletteOptions['primary'];
    lightgreen?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    lightgrey: true;
  }
}

// Create a theme instance.
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#283C32',
      dark: '#375046',
    },
    secondary: {
      main: '#73AF69',
    },
    lightgrey: {
      main: '#eeeeee',
    },
    mediumgrey: {
      main: '#909090',
    },
    darkgrey: {
      main: '#666666',
    },
    lightgreen: {
      main: '#73AF69',
    },
    basicblack: {
      main: '#333333',
    },
    background: {
      default: '#FFFFFF',
      paper: '#ffffff',
    },
    danger: {
      main: '#B30000',
    },
    success: {
      main: '#008024',
    },
    info: {
      main: '#024DBC',
    },
    warning: {
      main: '#FD7E14',
    },
    error: {
      main: '#CD5F3C',
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: "'Nunito Sans', sans-serif",
    body1: {
      fontSize: 16,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    body2: {
      fontSize: 16,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 400,
    },
    h1: {
      fontSize: 40,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    h2: {
      fontSize: 32,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    h3: {
      fontSize: 28,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    h4: {
      fontSize: 24,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    h5: {
      fontSize: 20,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    h6: {
      fontSize: 16,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
    button: {
      fontSize: 14,
      fontFamily: "'Nunito Sans', sans-serif",
      fontWeight: 700,
    },
  },
});

export default theme;
